import { useEffect, useState } from "react";

const API_URL: string = process.env.GATSBY_API_URL;

interface UserData {
  name: string;
  picture30x30: string;
}

const useUserLogged = (): { isLogged: boolean; userData: UserData | null } => {
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [userData, setUserData] = useState<UserData | null>(null);

  useEffect(() => {
    const checkUserLogged = async () => {
       const sessionCookie = decodeURIComponent(document.cookie)
          .split(';')
          .map(c => c.trim())
          .find(c => c.startsWith('sessionid='))
          ?.split('=')[1];

      if (!sessionCookie) {
        setIsLogged(false);
        setUserData(null);
        return;
      }

      try {
        if(!API_URL){
          throw new Error('The GATSBY_API_URL environment variable is not defined.');
        }

        const response = await fetch(API_URL, {
          method: "POST",
          credentials: "include",
          mode: "cors",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: "query { me { ... on Me { user { name, picture30x30 } } } }",
            variables: {},
          }),
        });

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Response is not JSON");
        }

        const json = await response.json();
        const user = json?.data?.me?.user;

        if (user) {
          setIsLogged(true);
          setUserData(user);
        } else {
          setIsLogged(false);
          setUserData(null);
        }
      } catch (error) {
        console.error("Error fetching user status:", error);
        setIsLogged(false);
        setUserData(null);
      }
    };

    void checkUserLogged();
  }, []);

  return { isLogged, userData };
};

export default useUserLogged;